/**
 * File Share project connector dropdown helpers.
 * Only Connected tokens should be assignable as storage / translation connectors.
 */

export function isConnectorConnected(status) {
  return typeof status === 'string' && status.trim().toLowerCase() === 'connected';
}

/**
 * Keep Connected connectors, plus the currently selected id (if any) so an
 * already-assigned Disconnected token still displays and can be changed.
 */
export function filterConnectedConnectors(connectors, selectedId = null) {
  if (!Array.isArray(connectors)) {
    return [];
  }
  const selected = selectedId != null && selectedId !== '' ? String(selectedId) : null;
  return connectors.filter((c) => {
    if (isConnectorConnected(c.status)) {
      return true;
    }
    return selected != null && c.id != null && String(c.id) === selected;
  });
}
